<template>
  <div>
    <el-page-header class="header" content="设备详细" @back="$router.back()" />
    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane label="设备信息" name="one">
        <power-station-detail-one />
      </el-tab-pane>
      <!-- <el-tab-pane label="基础信息" name="three">
        <power-station-detail-three />
      </el-tab-pane> -->
      <el-tab-pane label="插座信息" name="four">
        <power-station-detail-four />
      </el-tab-pane>
      <!-- <el-tab-pane label="充电记录" name="two">
        <power-station-detail-two/>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import PowerStationDetailOne from "./PowerStationDetail/PowerStationDetailOne";
// import PowerStationDetailTwo from "./PowerStationDetail/PowerStationDetailTwo";
// import PowerStationDetailThree from "@/views/PowerStationManage/PowerStationDetail/PowerStationDetailThree";
import PowerStationDetailFour from "@/views/PowerStationManage/PowerStationDetail/PowerStationDetailFour";

export default {
  name: "PowerStationDetail",
  components: {
    // PowerStationDetailTwo,
    PowerStationDetailOne,
    // PowerStationDetailThree,
    PowerStationDetailFour,
  },
  data() {
    return {
      activeTab:
        this.$route.query.activeTab == undefined
          ? "one"
          : this.$route.query.activeTab,
    };
  },
};
</script>
<style lang="sass" scoped>
.header
  margin-bottom: 10px
</style>
